import { encodeQuestionHideWhen, decodeQuestionHideWhen } from '../questionHideWhen'; // Handle side effects of deleting a question
// NOTE: Creates side effects on sections' questions

export default function deleteQuestionUpdates(result, questions, deletedQuestion) {
  questions // Get all questions with hideWhen rules
  .filter(question => Boolean(question.hideWhen)).forEach(question => {
    // Decode each hide when ruleset
    const ruleset = decodeQuestionHideWhen(`${question.hideWhen}`); // Remove subscription to the deleted question

    delete ruleset.questions[deletedQuestion.id];
    question.hideWhen = encodeQuestionHideWhen(ruleset); // Remove empty hide when ruleset

    if (!question.hideWhen) delete question.hideWhen;
  });
  return result;
}